(function (t) {
// sv
t.add("label_previous", "F\u00f6reg\u00e5ende", "KnpPaginatorBundle", "sv");
t.add("label_next", "N\u00e4sta", "KnpPaginatorBundle", "sv");
})(Translator);
